<template>
  <div
    :style="styles.base"
    :class="getCss('base')"
  />
</template>

<script>

import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CBorder',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'border-',
    };
  },
};
</script>
<style lang="scss">
  @import './border.scss';
</style>
